import Phaser from 'phaser';

export class CameraController {
  private mainCamera: Phaser.Cameras.Scene2D.Camera;

  constructor(scene: Phaser.Scene) {
    this.mainCamera = scene.cameras.main;
  }

  public setupCamera(target: Phaser.GameObjects.GameObject, worldWidth: number, worldHeight: number): void {
    this.mainCamera.setBounds(0, 0, worldWidth, worldHeight);
    this.mainCamera.startFollow(target, true, 0.08, 0.08);
    this.mainCamera.setDeadzone(100, 80);
    this.mainCamera.setZoom(1.0);
  }

  public shake(duration = 200, intensity = 0.01): void {
    this.mainCamera.shake(duration, intensity);
  }

  public flash(duration = 300): void {
    this.mainCamera.flash(duration, 255, 255, 255);
  }
}
